/**
 * Adapter: delegates ITooltipContentPort to services/tooltipContentService.
 */
import { tooltipContentService } from '../../../services/tooltipContentService';
import type { ITooltipContentPort } from '../../domain/ports/ITooltipContentPort';

export class TooltipContentAdapter implements ITooltipContentPort {
  async initialize(): Promise<void> {
    await tooltipContentService.initialize();
  }

  isReady(): boolean {
    return tooltipContentService.isInitialized();
  }
}